import axios from 'axios'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'

export const getDispatchOts = (
  filters?: Filter[],
  page = 0,
  pageSize = 20,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(`${ApiConfig.DispatchOt}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (Array.isArray(element.value)) {
        // Para arrays (como typePositionId, typeMovementId)
        element.value.forEach((val) => {
          url.searchParams.append(element.key, val.toString())
        })
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  if (orderBy && orderBy.field) {
    url.searchParams.set('sorter', `${orderBy.field},${orderBy.direction}`)
  }

  return axios.get(url.toString())
}

export const exportDispatchOtsToExcel = (filters?: Filter[]) => {
  const date = new Date()
  const offset = date.getTimezoneOffset()

  const url = new URL(`${ApiConfig.DispatchOt}/DispatchOtExcel`)
  url.searchParams.set('offset', offset.toString())

  if (filters) {
    filters.forEach((element) => {
      if (Array.isArray(element.value)) {
        element.value.forEach((val) => {
          url.searchParams.append(element.key, val.toString())
        })
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.get(url.toString())
}

// Función para obtener información del OT (para el componente OtDescription)
export const getOtDescription = (workOrderId?: number): Promise<any> => {
  const url = new URL(`${ApiConfig.DispatchOt}/${workOrderId}`)
  return axios.get(url.toString())
}

// Función para obtener stocks disponibles para completar OT
export const getAvailableStocks = (
  workOrderId: number,
  skuId: number
): Promise<any> => {
  const url = new URL(
    `${ApiConfig.WorkOrderApi}/GetCompleteWorkOrderStock/${workOrderId}/${skuId}`
  )
  return axios.get(url.toString())
}

export const postDispatchWorkOrder = (workOrderId: number, userId: number) => {
  return axios.post(`${ApiConfig.DispatchOt}/DispatchWorkOrder`, {
    workOrderId,
    userId
  })
}
